export default "__VITE_ASSET__185de00b__"